import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Users } from "lucide-react";
import { pkr, dateRange, VIBE_NAMES, DURATION_NAMES } from "@/lib/api";
import { ScarcityTag } from "@/components/TrustBadges";

export default function ListingCard({ l, tall = false, reasons }) {
  return (
    <Link to={`/l/${l.slug}`} className="group block transition-transform duration-300 hover:-translate-y-1" data-testid={`listing-card-${l.slug}`}>
      <div className={`relative overflow-hidden rounded-xl bg-muted ${tall ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
        <img src={l.hero_image} alt={l.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute left-3 top-3 flex flex-wrap gap-2">
          <ScarcityTag spotsLeft={l.spots_left} capacity={l.capacity} />
          {l.audience === "women-only" && <span className="eyebrow rounded-full bg-white/90 px-2.5 py-1 text-primary">Women-only</span>}
          {l.private_buy_enabled && l.seats_sold === 0 && <span className="eyebrow rounded-full bg-white/90 px-2.5 py-1 text-primary">Private buy open</span>}
        </div>
      </div>
      <div className="mt-4">
        <div className="eyebrow text-secondary">{VIBE_NAMES[l.vibe]} · {DURATION_NAMES[l.duration_type]}</div>
        <h3 className="mt-1.5 text-xl leading-snug tracking-tight text-foreground group-hover:text-primary">{l.title}</h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" strokeWidth={1.5} />{l.destination}</span>
          <span>{dateRange(l.start_date, l.end_date)}</span>
          <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" strokeWidth={1.5} />{l.capacity} max</span>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <div className="text-sm"><span className="font-semibold text-foreground" data-testid="listing-card-price">{pkr(l.price_pkr)}</span><span className="text-muted-foreground"> / person</span></div>
          {l.partner_verified && <span className="inline-flex items-center gap-1 text-xs text-primary"><BadgeCheck className="h-3.5 w-3.5" />{l.partner_name}</span>}
        </div>
        {reasons?.length > 0 && (
          <ul className="mt-3 space-y-1 border-t border-border pt-3 text-xs text-muted-foreground">
            {reasons.map((r) => <li key={r}>— {r}</li>)}
          </ul>
        )}
      </div>
    </Link>
  );
}
